
export default function SendFunction() {
    // this.send = window.SendFunction;

    this.saveIOS = function (url) {
        window.SendFunction.saveIOS(url)
    };

    this.saveAndroid = function (url) {
        window.SendFunction.saveAndroid(url)
    };

}

